import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPressurizedVessel = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 100,
	height: 200,
	viewBox: "0 0 100.0 200.0",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M 0.0 15.0 A 50.0 15.0 0.0 1 1 100.0 15.0 L 100.0 185.0 A 50.0 15.0 0.0 1 1 0.0 185.0 Z",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	})
});
export default SvgPressurizedVessel;
